module.exports = __webpack_public_path__ + "static/media/friend-coins.8c087aef.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/TradeModals/ReferralBonus/images/friend-coins.png
// module id = 1671
// module chunks = 103